import { IState, DefaultState } from "./state";
import { Types, Keys } from "./action/types";
import { room } from "../../../model/room";
import { SelectItem } from "../../../ui-components/select/Select";

export const reducer = (
  state: IState = DefaultState(),
  action: Types
): IState => {
  switch (action.type) {
    case Keys.LOADRESERVATIONROOM_PENDING: {
      //let q: any[] = action.payload;
      return {
        ...state,
        areLoadingReservationRooms: true,
      };
    }
    case Keys.LOADRESERVATIONROOM_FULFILLED: {
      let q = action.payload;
      return {
        ...state,
        reservationRooms: q.length === undefined ? [q] : q,
        areLoadingReservationRooms: false,
      };
    }
    case Keys.LOADRESERVATIONROOM_REJECTED: {
      return {
        ...state,
        reservationRooms: undefined,
        areLoadingReservationRooms: false,
      };
    }
    case Keys.LOADROOMS_FULFILLED: {
      let q: Array<room> = action.payload;
      let roomList: SelectItem[] = [];
      q.forEach((element) =>
        roomList.push({ name: element.description, value: element._id })
      );
      return {
        ...state,
        roomList: roomList,
      };
    }
    case Keys.LOADROOMS_REJECTED: {
      return {
        ...state,
        roomList: [],
      };
    }
    case Keys.LOADRESEVATIONSSLOT_PENDING: {
      return {
        ...state,
        loadingReservations: true,
      };
    }
    case Keys.LOADRESEVATIONSSLOT_FULFILLED: {
      let p: any[] = action.payload;
      return {
        ...state,
        loadingReservations: false,
        reservations: p,
      };
    }
    case Keys.LOADRESEVATIONSSLOT_REJECTED: {
      return {
        ...state,
        loadingReservations: false,
        reservations: [],
      };
    }
    case Keys.ADDRESERVATION_PENDING: {
      return {
        ...state,
        addingReservation: true,
      };
    }
    case Keys.ADDRESERVATION_FULFILLED: {
      return {
        ...state,
        addingReservation: false,
        reservationResponse: action.payload
      };
    }
    case Keys.ADDRESERVATION_REJECTED: {
      return {
        ...state,
        addingReservation: false,
        reservationResponse: { result: false, message: "Errore Imprevisto, Prenotazione non effettuata" },
      };
    }
    case Keys.DELETERESERVATION_PENDING: {
      return {
        ...state,
        deletingReservation: true,
      };
    }
    case Keys.DELETERESERVATION_FULFILLED: {
      return {
        ...state,
        deletingReservation: false,
        reservations: action.payload.result ? state.reservations.filter(r => r.reservationId !== action.meta) : state.reservations,
        reservationResponse: action.payload
      };
    }
    case Keys.DELETERESERVATION_REJECTED: {
      return {
        ...state,
        addingReservation: false,
        reservationResponse: { result: false, message: "Errore Imprevisto, Prenotazione non eliminata" },
      };
    }
    case Keys.SETROOMSELECTED: {
      return {
        ...state,
        roomSelected: action.payload
      };
    }
    case Keys.SETDAYSELECTED: {
      return {
        ...state,
        dayView: action.payload
      };
    }
    case Keys.UPDATEVIEWTYPE: {
      return {
        ...state,
        viewType: action.payload
      };
    }
    case Keys.RESETRESPONSE: {
      return {
        ...state,
        reservationResponse: undefined
      };
    }
    default:
      return state;
  }
};
